import ReactDOM from "react-dom/client";
import App from "./app/index.tsx";
import "./index.css";

// Import and init Sentry SDK
import * as Sentry from "@sentry/react";
import ENV from "./utils/env.ts";
import { StrictMode } from "react";

/* ENVs */
// there is only a dsn set for production
const SENTRY_DSN = ENV.SENTRY_DSN;

Sentry.init({
  dsn: SENTRY_DSN,
  environment: import.meta.env.MODE,
  release: APP_VERSION, // This is the version set in the package.json file
  integrations: [
    Sentry.replayCanvasIntegration(),

    Sentry.replayIntegration({
      // disable all the default privacy mask options
      maskAllInputs: false,
      maskAllText: false,
      blockAllMedia: false,
      networkDetailAllowUrls: [
        "https://api.dragonflyai.co",
        "https://staging.api.dragonflyai.co",
        "https://df-staging-pipeline-images.s3.eu-west-1.amazonaws.com/*",
        "https://df-prod-pipeline-images.s3.eu-west-1.amazonaws.com/*",
        // Matches staging S3 URLs
        /^https:\/\/df-staging-pipeline-images\.s3\.eu-west-1\.amazonaws\.com/,
        // Matches production S3 URLs
        /^https:\/\/df-prod-pipeline-images\.s3\.eu-west-1\.amazonaws\.com/,
      ],
      networkRequestHeaders: ["Cookie"],
      networkResponseHeaders: ["Set-Cookie"],
    }),
  ],
  // Session Replay
  replaysSessionSampleRate: 1.0, // Currently set to 100% for all sessions.
  replaysOnErrorSampleRate: 1.0, // This sets the sample rate at 100% for errors.
  tracesSampleRate: 0.2, // This sets the sample rate at 20%. We may want to adjust this if it's too high.
});

/* Render */
ReactDOM.createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
